import styled from "styled-components";
import pxFromCm from "../util/pxFromCm";
import { useEffect, useLayoutEffect, useRef, useState } from "react";


interface SubheaderPreviewProps {
  text: string;
  margin: number;
}

export default function SubheaderPreview(props: SubheaderPreviewProps) {
  const { text, margin } = props;
  const containerRef = useRef(null);
  const [extraMargin, setExtraMargin] = useState(pxFromCm(0.25));
  const [desiredHeight, setDesiredHeight] = useState(0);
  const [isFindingMargin, setFindingMargin] = useState(true);
  const [recursion, setRecursion] = useState(0);

  const increment = pxFromCm(0.5);

  useEffect(() => {
    setRecursion(0);
    setDesiredHeight(0);
    setFindingMargin(true);
    setExtraMargin(pxFromCm(0.25));
  }, [text]);

  // TODO this resizing is really suboptimal, but I couldn't figure out how to do it optimally
  useEffect(() => {
    if (!(containerRef && containerRef.current)  || recursion > 20) {
      return;
    }
    if (isFindingMargin) {
      if (desiredHeight === 0) {
        setDesiredHeight(containerRef.current.offsetHeight);
        setExtraMargin(extraMargin + increment);
        setRecursion(recursion + 1);
      } else if (containerRef.current.offsetHeight > desiredHeight || extraMargin > pxFromCm(6)) {
        setFindingMargin(false);
        setExtraMargin(extraMargin - increment);
      } else {
        setExtraMargin(extraMargin + increment);
        setRecursion(recursion + 1);
      }
    }
  }, [extraMargin, text, desiredHeight, containerRef])

  useLayoutEffect(() => {
    if (!(containerRef && containerRef.current)  || recursion > 20) {
      return;
    }
    if (isFindingMargin) {
      if (desiredHeight === 0) {
        setDesiredHeight(containerRef.current.offsetHeight);
        setExtraMargin(extraMargin + increment);
        setRecursion(recursion + 1);
      } else if (containerRef.current.offsetHeight > desiredHeight) {
        setFindingMargin(false);
        setExtraMargin(extraMargin - increment);
      } else {
        setExtraMargin(extraMargin + increment);
        setRecursion(recursion + 1);
      }
    }
  }, [extraMargin, desiredHeight, containerRef])

  return (
    <Container 
      ref={containerRef}
      style={{
        marginBottom: `${pxFromCm(0.35)}px`,
        marginLeft: `${extraMargin + margin}px`,
        marginRight: `${extraMargin + margin}px`,
      }}
    >
    {text}
  </Container>)
}

const Container = styled.div`
  text-align: center;
  /*font-style: italic;*/
`;
